import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import Topbar from '../../components/Topbar/Topbar';

const TutorialVideos = () => {
  const navigate = useNavigate();

    const [tabs, setTabs] = useState({ id: 1, name: "Languages", route: "" });
    
    const tabsList = [
      { id: 1, name: "Languages", route: "/tutorial-languages" },
      { id: 2, name: "Categories", route: "/tutorial-categories" },
      { id: 3, name: "Videos", route: "/videos-list" },
    ];

  return (
    <div>
      <Topbar header={"Tutorial Videos"} />
      <div className="d-flex  flex-wrap gap-3">
        {tabsList.map((tab)=>(<div
          onClick={() => {
            setTabs(tab);
            navigate(tab.route);
          }}
          className={`${tabs.id == tab.id ? "Act-tabs" : "tabs"} d-flex ac-jc `}
        >
          {tab.name}
        </div>))}
      </div>
    </div>
  );
}

export default TutorialVideos
